import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { Plus, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import StaffLayout from '../../layouts/StaffLayout';
import KanbanBoard from '../../components/KanbanBoard';
import { ordersApi } from '../../services/api';
import { formatApiError } from '../../utils/helpers';
import { useLanguage } from '../../contexts/LanguageContext';

export default function StaffKanbanPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: ['staff-orders-kanban'],
    queryFn: () => ordersApi.list({ limit: 100 }).then(r => r.data.items || []),
    refetchInterval: 15000,
  });

  const statusMutation = useMutation({
    mutationFn: ({ id, status }) => ordersApi.updateStatus(id, status),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['staff-orders-kanban'] });
      toast.success(t('Status pesanan diperbarui', 'Order status updated'));
    },
    onError: err => toast.error(formatApiError(err)),
  });

  return (
    <StaffLayout>
      <div className="space-y-5">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-xl font-bold text-slate-900 font-manrope">Kanban Board</h1>
            <p className="text-slate-500 text-sm mt-0.5">{t('Drag & drop untuk ubah status pesanan', 'Drag & drop to change order status')}</p>
          </div>
          <div className="flex gap-2">
            <button onClick={() => queryClient.invalidateQueries({ queryKey: ['staff-orders-kanban'] })}
              className="p-2.5 bg-white border border-slate-200 text-slate-600 rounded-xl hover:bg-slate-50 transition-colors">
              <RefreshCw size={18} />
            </button>
            <button onClick={() => navigate('/karyawan/order-create')}
              className="flex items-center gap-2 px-4 py-2.5 bg-[#0f6c44] text-white rounded-xl text-sm font-semibold hover:bg-[#0c5636] active:scale-95 transition-all shadow-sm">
              <Plus size={18} />{t('Buat Pesanan', 'New Order')}
            </button>
          </div>
        </div>
        <KanbanBoard
          orders={data || []}
          onStatusChange={(id, status) => statusMutation.mutate({ id, status })}
          isLoading={isLoading}
          adminPath="/karyawan"
        />
      </div>
    </StaffLayout>
  );
}
